import React, { createContext, useContext, useState } from 'react'

const LocalDataCacheContext = createContext()

export function LocalDataCacheProvider({ children }) {
  const [lifeEvents, setLifeEvents] = useState([])
  const [breadcrumbs, setBreadcrumbs] = useState([])

  const contextValue = React.useMemo(
    () => ({
      lifeEvents,
      setLifeEvents,
      breadcrumbs,
      setBreadcrumbs,
    }),
    [lifeEvents, setLifeEvents, breadcrumbs, setBreadcrumbs]
  )

  return <LocalDataCacheContext.Provider value={contextValue}>{children}</LocalDataCacheContext.Provider>
}

export function useLocalDataCache() {
  return useContext(LocalDataCacheContext)
}
